<template>
    <div class="ChallengeAllocationFilterBar">
        <div class="container-fluid">
          <div class="row vertical-align margin-top-2Perc margin-bottom-2Perc">
            <div class="col-md-1 col-lg-1">
            </div>  
            <div class="col-md-2 col-lg-2 text-align-right padding-left-right-0Px">
                Group Course(s)
            </div>    
            <div class="col-md-3 col-lg-3">
                <div class="form-group">
                    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 padding-left-right-0Px">
                        <select class="form-control" v-model="getSelectedGroupCourseObj">
                          <option value=-1 disabled>Select</option>
                          <option v-for="groupCourseObj in getGroupCourseList" v-bind:key="groupCourseObj.GroupCourseMasterId" v-bind:value="groupCourseObj">{{ groupCourseObj.GroupName }} :: {{groupCourseObj.CourseTitle}} {{groupCourseObj.CourseSubTitle !== null && groupCourseObj.CourseSubTitle.trim().length !== 0 ? '[' + groupCourseObj.CourseSubTitle + ']': ''}}</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="col-md-1 col-lg-1 text-align-right padding-left-right-0Px">
                Cohort(s)
            </div>    
            <div class="col-md-3 col-lg-3">
                <div class="form-group">
                    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 padding-left-right-0Px">
                        <select class="form-control" v-model="getSelectedCohortObj">
                        <option value='-1' disabled>Select</option>
                        <option v-for="cohortObj in getAssociatedCohorts" v-bind:key="cohortObj.CohortId" v-bind:value="cohortObj">{{ cohortObj.CohortName }}</option>
                      </select> 
                    </div>
                </div>
            </div>
            <div class="col-md-2 col-lg-2">
          </div>
        </div>
        <div class="row vertical-align margin-Top-2Perc margin-bottom-2Perc">
          <div class="col-md-2 col-lg-2">
          </div>  
          <div class="col-md-1 col-lg-1 text-align-right padding-left-right-0Px">
            Lesson(s)
          </div>    
          <div class="col-md-3 col-lg-3">
              <div class="form-group">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 padding-left-right-0Px">
                  <select class="form-control" v-model="getSelectedLessonObj">
                    <option value=-1 disabled>Select</option>
                    <option v-for="lessonObj in getLessonList" v-bind:key="lessonObj.ModuleId" v-bind:value="lessonObj" v-if="!lessonObj.IsBonusContent">{{lessonObj.Title}}</option>
                  </select>
                </div>
              </div>
          </div>
          <div class="col-md-1 col-lg-1 text-align-right padding-left-right-0Px">
            Step(s)
          </div>    
          <div class="col-md-3 col-lg-3">
              <div class="form-group">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 padding-left-right-0Px">
                  <select class="form-control" v-model="getSelectedStepObj">
                    <option value=-1 disabled>Select</option>
                    <option v-for="stepObj in getStepList" v-bind:key="stepObj.ElementId" v-bind:value="stepObj" v-if="showStep(stepObj)">{{stepObj.Title}}</option>
                  </select>
                </div>
              </div>
          </div>
          <div class="col-md-2 col-lg-2">
          </div>
        </div>
        <div class="row vertical-align margin-top-2Perc margin-bottom-2Perc">
          <div class="col-md-5 col-lg-5">
          </div>    
          <div class="col-md-2 col-lg-2">
            <button class="btn btn-primary btn-block unenroll-existing-button-BG black-font-color padding-left-right-0Px" v-on:click="checkAndEmit($event)">View</button>
          </div>
          <div class="col-md-5 col-lg-5">
        </div>
      </div>
      <hr width="97%" size="10px" class="margin-bottom-2Perc"/>
      <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
      <!-- Show Spinner -->
      <div class="animationload" v-show="showSpinner">
        <div class="osahanloading"></div>
      </div>
      <loader></loader>      
    </div>
  </div>    
</template>

<script>
import datePicker from 'vue-bootstrap-datetimepicker'
import { constants } from '@/utils/constants'
import { groupCourseService } from '@/server-util/group-course-service'
import { moduleService } from '@/server-util/module-service'
import { cohortService } from '@/server-util/cohort-service'
import AlertBox from '@/components/AlertOverlay'
import Loader from '@/components/dashboard/Loader'
import { elementService } from '@/server-util/element-service'
export default {
  created: function () {
    this.setDefaultValues()
    this.getAllGroupCourses()
  },
  data: function () {
    return {
      showAlertDialog: false,
      errorMsg: '',
      showSpinner: false,
      selectedGroupCourseObj: -1,
      selectedCohortObj: -1,
      selectedLessonObj: -1,
      selectedStepObj: -1,
      associatedCohortList: [],
      lessonList: [],
      stepList: []
    }
  },
  methods: {
    showStep: function (selectedStep) {
      if (selectedStep.Type === 1 && selectedStep.ElemChallenge.FeedbackType === constants.ChallengeFeedbackType.Regular_Challenge && selectedStep.ElemChallenge.AllocateManually) {
        return true
      } else {
        return false
      }
    },
    setDefaultValues: function () {},
    checkAndEmit: function (event) {
      if (this.selectedGroupCourseObj !== -1) {
        if (this.selectedCohortObj !== -1) {
          if (this.selectedLessonObj !== -1) {
            if (this.selectedStepObj !== -1) {
              // AK: Emit selected values in the form of object
              var objToPost = {
                selectedGroupCourseObj: this.selectedGroupCourseObj,
                selectedCohortObj: this.selectedCohortObj,
                selectedLessonObj: this.selectedLessonObj,
                selectedStepObj: this.selectedStepObj
              }
              this.$emit('selectedValues', objToPost)
            } else {
              this.showAlertDialog = true
              this.errorMsg =
              'Please select a step.'
            }
          } else {
            this.showAlertDialog = true
            this.errorMsg =
            'Please select a lesson.'
          }
        } else {
          this.showAlertDialog = true
          this.errorMsg =
            'Please select a cohort.'
        }
      } else {
        this.showAlertDialog = true
        this.errorMsg =
          'Please select a group course.'
      }
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    },
    getAssociatedCohortList: function () {
      var storeObj = this.$store
      var _this = this
      if (
        this.selectedGroupCourseObj !== -1
      ) {
        // _this.showSpinner = true
        _this.$store.state.isLoading = true
        cohortService
          .getCohortListUsingGroupCourse(
            storeObj.state.access_token,
            this.selectedGroupCourseObj.GroupCourseMasterId
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Hide Spinner after recieving Cohort list response
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
              if (responseObj.data.length === 0) {
                this.showAlertDialog = true
                var subTitleName = this.selectedGroupCourseObj.CourseSubTitle === null ? '' : ' [' + this.selectedGroupCourseObj.CourseSubTitle + ']'
                this.errorMsg = 'No cohort found in \'' + this.selectedGroupCourseObj.GroupName + ' :: ' + this.selectedGroupCourseObj.CourseTitle + subTitleName + '\'.'
                this.selectedCohortObj = -1
              }
              this.associatedCohortList = responseObj.data
              this.getLessons()
            } else {
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
              // AK: Hide Spinner if error occured
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
            }
          }, errorObj => {
            // AK: Hide Spinner if error occured
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'Select Group ID is NULL hence declined LISTING Associated Cohort(s) OPERATION'
        )
      }
    },
    getLessons () {
      if (this.selectedGroupCourseObj.CourseMasterId !== undefined) {
        // this.showSpinner = true
        this.$store.state.isLoading = true
        var storeObj = this.$store
        var _this = this
        moduleService
          .listModules(
            storeObj.state.access_token,
            _this.selectedGroupCourseObj.CourseMasterId
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              _this.lessonList = responseObj.data
              _this.$store.state.isLoading = false
            } else {
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
            }
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
          }, errorObj => {
            // _this.showSpinner = false
            _this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        this.showAlertDialog = true
        this.errorMsg = 'Please select a valid group course.'
      }
    },
    getElements: function () {
      var storeObj = this.$store
      var _this = this
      _this.$store.state.isLoading = true
      if (
        this.selectedLessonObj.ModuleId !== undefined ||
        this.selectedLessonObj.ModuleId !== null ||
        this.selectedLessonObj.length > 0
      ) {
        elementService
          .listElements(storeObj.state.access_token, this.selectedLessonObj.ModuleId)
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              _this.stepList = responseObj.data
              _this.$store.state.isLoading = false
              this.showElementList = true
            } else {
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
              // this.showSpinner = false
              this.$store.state.isLoading = false
            }
          }, errorObj => {
            this.$store.state.isLoading = false
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'ModuleId is NULL hence declined LOADING ELEMENT LIST OPERATION'
        )
      }
    },
    getAllGroupCourses: function () {
      var storeObj = this.$store
      var _this = this
      if (
        storeObj.state.access_token !== undefined || storeObj.state.access_token !== ''
      ) {
        // AK: If group courses are not available then only show spinner
        if (storeObj.state.groupCourseList.length === 0) {
          // _this.showSpinner = true
          _this.$store.state.isLoading = true
        }
        groupCourseService
          .getGroupCourseList(
            storeObj.state.access_token
          )
          .then(responseObj => {
            if (responseObj.status >= 200 && responseObj.status < 300) {
              // AK: Store it
              storeObj.state.groupCourseList = responseObj.data
              if (_this.$store.state.isLoading === true) {
                // AK: Hide Spinner after recieving Group Course list
                // _this.showSpinner = false
                _this.$store.state.isLoading = false
              }
            } else {
              this.showAlertDialog = true
              this.errorMsg = 'Oops! Something went wrong. Please try again.'
              if (this.$store.state.isLoading === true) {
                // AK: Hide Spinner after recieving Group Course list
                // _this.showSpinner = false
                _this.$store.state.isLoading = false
              }
            }
          }, errorObj => {
            if (_this.$store.state.isLoading === true) {
              // AK: Hide Spinner after recieving Group Course list
              // _this.showSpinner = false
              _this.$store.state.isLoading = false
            }
            this.showAlertDialog = true
            if (errorObj.response === undefined) {
              this.errorMsg = constants.No_Internet_Connection_Msg
            } else {
              this.errorMsg = errorObj.response.statusText
            }
          })
      } else {
        console.log(
          'Access Token is NULL hence declined GROUP COURSE LISTING OPERATION'
        )
      }
    }
  },
  components: {
    'alert-box': AlertBox,
    'date-picker': datePicker,
    'loader': Loader
  },
  computed: {
    getGroupCourseList: {
      get: function () {
        return this.$store.state.groupCourseList
      }
    },
    getAssociatedCohorts: {
      get: function () {
        return this.associatedCohortList
      }
    },
    getLessonList: {
      get: function () {
        return this.lessonList
      }
    },
    getSelectedGroupCourseObj: {
      get: function () {
        return this.selectedGroupCourseObj
      },
      set: function (newValue) {
        this.selectedCohortObj = -1
        this.selectedLessonObj = -1
        this.selectedStepObj = -1
        this.associatedCohortList = []
        this.lessonList = []
        this.stepList = []
        this.selectedGroupCourseObj = newValue
        this.getAssociatedCohortList()
      }
    },
    getSelectedCohortObj: {
      get: function () {
        return this.selectedCohortObj
      },
      set: function (newValue) {
        this.selectedCohortObj = newValue
      }
    },
    getSelectedLessonObj: {
      get: function () {
        return this.selectedLessonObj
      },
      set: function (newValue) {
        this.selectedLessonObj = newValue
        this.selectedStepObj = -1
        this.stepList = []
        this.getElements()
      }
    },
    getSelectedStepObj: {
      get: function () {
        return this.selectedStepObj
      },
      set: function (newValue) {
        this.selectedStepObj = newValue
      }
    },
    getStepList: {
      get: function () {
        return this.stepList
      }
    }
  },
  watch: {},
  name: 'ChallengeAllocationFilterBar'
}
</script>

<style scoped>
.ChallengeAllocationFilterBar {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.padding-left-right-0Px {
  padding-left: 0px !important;
  padding-right: 0px !important;
}
.padding-left-0Px {
  padding-left: 0px !important;
}
.padding-left-1Perc {
  padding-left: 1% !important;
}
.btn {
  white-space: normal !important;
  word-wrap: break-word;
}
.background-gray {
  background-color: aqua;
}
.overflow-y-hidden {
  overflow-y: hidden !important;
}
.overflow-hidden {
  overflow: hidden;
}
.save-button-width {
  width: 60% !important;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.white-BG {
  background-color: #ffffff;
}
.MainDiv {
  overflow-y: hidden !important;
}
.margin-Top-2Perc {
  margin-top: 2%;
}
.align-center {
  margin: 0 auto !important;
}
.left-border {
  border-left: 1px solid #aaa;
}
.custom-btn {
  padding: 5px 12px !important;
}
.black-border {
  border: 1px solid black;
}
.grey-border {
  border: 1px solid #aaa;
}
.center-block {
  float: none;
  margin-left: auto;
  margin-right: auto;
}
.cursor-pointer {
  cursor: pointer;
}
.text-align-left {
  text-align: left !important;
}
.font-size-20px {
  font-size: 20px;
}
.font-weight-bold {
  font-weight: bold;
}
.width {
  width: 5%;
}
.close-img-width-height {
  width: 2%;
  height: 2%;
}
.margin-top-1Perc {
  margin-top: 1%;
}
.margin-top-2Perc {
  margin-top: 2%;
}
.margin-top-3Perc {
  margin-top: 3%;
}
.margin-top-4Perc {
  margin-top: 4%;
}
.float-right {
  float: right;
}
.unenroll-existing-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.black-font-color {
  color: #000;
}
.width-15px{
  width: 15%;
}
.margin-left-4Perc{
  margin-left:4% !important;
}
.text-align-right{
  text-align: right;
}
.width-7Perc{
  width:7% !important;
}
.margin-left-1Point5Perc{
  margin-left: 1.5% !important;
}

.margin-bottom-4Perc{
  margin-bottom:4% !important;
}
.margin-bottom-2Perc{
  margin-bottom:2% !important;
}
</style>


// WEBPACK FOOTER //
// src/components/users/challenge_allocation/ChallengeAllocationFilterBar.vue